import React from "react";

const SearchSuggestion = ({ content, type, onClick, id=null, name=null,hover_color="#e1e1e1" }) => {

    let style_str = `.search-suggestion {
        padding: 10px;
        border-radius: 10px;
      }

      .search-suggestion:hover {
        background: ` + hover_color + `
      }

      .search-suggestion.highlighted {
        background: ` + hover_color + `
      }
`
  

    return (
      <>
        <style>{style_str}</style>
        <div role="button" className="search-suggestion flex-column" style={{gap: "2px"}} onClick={onClick}> 
            <div className="flex-row space-between">
              <span className="font-xs">Attribute: {type}</span>
              <div className="flex-column">
              {name && <span className="font-xs">Name: #{name}</span>}
              </div>
            </div>
            <span className="font-medium" style={{wordBreak: "break-word"}}>{content}</span>
        </div>
      </>
    );
  };
  
export default SearchSuggestion;